var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQueued(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 8C1.7945 8 0 6.2055 0 4C0 1.7945 1.7945 0 4 0C6.2055 0 8 1.7945 8 4C8 6.2055 6.2055 8 4 8ZM5.1465 5.6465C5.0185 5.6465 4.8905 5.5975 4.793 5.5L3.6465 4.3535C3.5525 4.26 3.5 4.1325 3.5 4V2C3.5 1.724 3.7235 1.5 4 1.5C4.2765 1.5 4.5 1.724 4.5 2V3.793L5.5 4.793C5.6955 4.9885 5.6955 5.3045 5.5 5.5C5.4025 5.5975 5.2745 5.6465 5.1465 5.6465Z",
    fill: "#202223"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueued);
export default __webpack_public_path__ + "static/media/Queued.40ffb4d3e233dfe30a1ef9bcc5f1c207.svg";
export { ForwardRef as ReactComponent };